import { Termin, Utbetalingsplan } from './Models/Utbetalingsplan';

export const beregnStipendOgLan = (
    antallManeder: number,
    skolepengebelop: number,
    studiepoeng: number,
    basisstotte: number,
): number => {
    let totalsum = 0;

    if (antallManeder >= 10) {
        totalsum = (antallManeder * basisstotte) / (60 / studiepoeng) + skolepengebelop;
    } else {
        totalsum = (antallManeder * basisstotte) / (30 / studiepoeng) + skolepengebelop;
    }
    return totalsum;
};

export const beregnStipend = (borteboer: boolean, totalsum: number, skolepenger: number): number => {
    return borteboer ? (totalsum - skolepenger) * 0.4 : 0;
};

export const beregnLan = (borteboer: boolean, totalsum: number, skolepenger: number): number => {
    return borteboer ? (totalsum - skolepenger) * 0.6 + skolepenger : totalsum;
};

export const beregnUtbetalingsplan = (
    hostManeder: number,
    varManeder: number,
    stipendOgLan: number,
    skolepenger: number,
): Utbetalingsplan => {
    const stipendOgLanUtenSkolepenger = stipendOgLan - skolepenger;
    const skalHaJuniBetaling = varManeder === 6;
    const harHostPeriode = hostManeder > 0;
    const harVarPeriode = varManeder > 0;
    const heltSkolear = harHostPeriode && harVarPeriode;

    const stipendOgLanDeltPaAntallManeder = stipendOgLanUtenSkolepenger / (varManeder + hostManeder);

    const stipendOgLanVar = stipendOgLanDeltPaAntallManeder * varManeder;
    const stipendOgLanHost = stipendOgLanDeltPaAntallManeder * hostManeder;

    const stipendOgLanJuni = skalHaJuniBetaling ? stipendOgLanVar / varManeder : 0;
    const stipendOgLanVanUtenJuni = stipendOgLanVar - stipendOgLanJuni;
    const skolepengerHalvar = heltSkolear ? skolepenger / 2 : skolepenger;

    const hostPeriode = harHostPeriode
        ? beregnPeriode(8, hostManeder, stipendOgLanHost, skolepengerHalvar)
        : new Array<Termin>();
    const vanligeVarManeder = skalHaJuniBetaling ? varManeder - 1 : varManeder;
    const varPeriode = harVarPeriode
        ? beregnPeriode(1, vanligeVarManeder, stipendOgLanVanUtenJuni, skolepengerHalvar)
        : new Array<Termin>();

    if (skalHaJuniBetaling) {
        varPeriode.push({
            mnd: 6,
            terminbelop: stipendOgLanJuni,
        });
    }

    return {
        terminerhost: harHostPeriode
            ? {
                  sum: stipendOgLanHost + skolepengerHalvar,
                  terminer: hostPeriode,
              }
            : null,
        terminervar: harVarPeriode
            ? {
                  sum: stipendOgLanVar + skolepengerHalvar,
                  terminer: varPeriode,
              }
            : null,
    };
};

const beregnPeriode = (
    startManed: number,
    antallManeder: number,
    stipendOgLanPeriode: number,
    skolepengerPeriode: number,
): Termin[] => {
    const periode = new Array<Termin>();
    periode.push({
        mnd: startManed,
        terminbelop: stipendOgLanPeriode * 0.4 + skolepengerPeriode,
    });

    const andreManed = startManed + 1;
    const sisteManed = startManed + antallManeder;
    for (let maned = andreManed; maned < sisteManed; maned++) {
        periode.push({
            mnd: maned,
            terminbelop: stipendOgLanPeriode * 0.15,
        });
    }

    return periode;
};
